const experiences = [
  {
    heading: "St. Gregorios English School",
    sub: "Rourkela",
    date: "Nov 2014 - 2020",
    description: "Class 6th to 10th",
    alignment: "left",
    type: "school",
  },
  {
    heading: "Vikash Residential School",
    sub: "Bargarh",
    date: "Nov 2020 - 2022",
    description: "Class 11th to 12th",
    alignment: "right",
    type: "school",
  },
  {
    heading: "National Institute of Technology",
    sub: "Rourkela",
    date: "Nov 2022 - present",
    description: "Bachelor of Technology",
    alignment: "left",
    type: "school",
  },
  {
    heading: "800+ DSA Problems Solved",
    sub: "Data Structures and Algorithms",
    date: "Nov 2023 - present",
    description:
      "Solved over 800 DSA problems across platforms like LeetCode, GeeksforGeeks, CodeChef, and HackerRank. Achieved a global rank of 261 among 10,000+ participants in CodeChef Starters 198.",
    alignment: "right",
  },
  {
    heading: "Data Science and ML Intern",
    sub: "Encryptyx",
    date: "June 2024 - July 2024",
    description: "Built an ML-based project and integrated it with a frontend interface.",
    alignment: "left",
    type: "work",
  },
  {
    heading: "Software Engineering Intern",
    sub: "Vizora Enterprises, Noida",
    date: "May 2025 - July 2025",
    description:
      "Engineered a scalable microservices system using Node.js, Express, RabbitMQ, and Cloudinary; optimized REST APIs with JWT auth and role-based access control.",
    alignment: "right",
    type: "work",
  },
];

export default experiences;
